import { AppstoreOutlined } from "@ant-design/icons";
import { t } from "@airange/shared/i18n-platform-shell";
import type { ReactNode } from "react";
import { AdminShellActions, buildAdminAvatarProps, type AdminShellAvatarConfig, type AdminShellLinkItem } from "./admin-shell-actions";

export type PlatformShellAppKey =
  | "airange-admin"
  | "airange-environment"
  | "airange-assets"
  | "airange-identity"
  | "aitest"
  | "edu-admin";

export type PlatformShellActionsProps = {
  currentApp: PlatformShellAppKey;
  localeNode?: ReactNode;
  portalBaseUrl?: string;
  platformAdminBaseUrl?: string;
  includePortalLink?: boolean;
  includePlatformAdminLink?: boolean;
  extraLinks?: AdminShellLinkItem[];
};

export function PlatformShellActions({
  currentApp,
  localeNode,
  portalBaseUrl,
  platformAdminBaseUrl,
  includePortalLink = true,
  includePlatformAdminLink,
  extraLinks = [],
}: PlatformShellActionsProps) {
  const links: AdminShellLinkItem[] = [];

  if (includePortalLink && portalBaseUrl) {
    links.push({
      key: "portal",
      label: t("platform.admin.links.portal"),
      icon: <AppstoreOutlined />,
      href: portalBaseUrl,
    });
  }

  const shouldShowPlatformAdminLink = includePlatformAdminLink ?? currentApp !== "airange-admin";
  if (shouldShowPlatformAdminLink && platformAdminBaseUrl) {
    links.push({
      key: "platform-admin",
      label: t("platform.admin.links.platformAdmin"),
      href: platformAdminBaseUrl,
    });
  }

  return AdminShellActions({
    localeNode,
    links: [...links, ...extraLinks],
  });
}

export function buildPlatformShellAvatarProps(config: AdminShellAvatarConfig) {
  return buildAdminAvatarProps(config);
}
